'use client'

import { ReactNode } from 'react'

import { useAirbridgeContext } from '@/shared/config'
import { passPropsToSingleChild } from '@/shared/lib'

import { RoomShareEventPayload } from './room-share-event'

type Props = {
  airbridgeObject: RoomShareEventPayload
  children: ReactNode
}

export const RoomShareEventInjector = ({
  airbridgeObject,
  children,
}: Props) => {
  const { sendEvent } = useAirbridgeContext()

  const handleShare = () => {
    sendEvent(airbridgeObject)
  }

  return passPropsToSingleChild(children, { onShared: handleShare })
}
